import { makeQueryStringDync, toFormUrlEncoded, errorHandlerMiddleware, setHeader, getNotInContentProvider } from "../../helper.js";
let controller =  null;

const actions = {
  contentList: (context, payload) => {
    const contentRestrictionPlanIds = context.getters.appConfig.contentRestrictionPlanIds || {};
    const subscriptionList = context.getters.subscriptionList || [];
    return new Promise((resolve, reject) => {

      if ( !payload.endpoint ) {
        reject(false)
        return false;
      }
      let categoryPayload = JSON.parse(JSON.stringify(payload));

      if (categoryPayload?.params?.category) {
        categoryPayload.params.category = encodeURI(JSON.stringify([categoryPayload?.params?.category]));
      }
   
      if (categoryPayload?.params?.orderby) {
        categoryPayload.params.orderby = encodeURI(JSON.stringify(categoryPayload?.params?.orderby));
      } 

      if (categoryPayload?.params?.incontentprovider) {
        categoryPayload.params.incontentprovider = encodeURIComponent(JSON.stringify(categoryPayload?.params?.incontentprovider));
      } else if(context?.getters?.appConfig?.featureEnabled?.isNotInContentProvider && getNotInContentProvider(subscriptionList, contentRestrictionPlanIds)) {
        categoryPayload.params.notincontentprovider = encodeURIComponent(JSON.stringify(getNotInContentProvider(subscriptionList, contentRestrictionPlanIds)));
      }
      let data = makeQueryStringDync(categoryPayload.params);
      fetch(`${context.getters.vCmsCachingBaseUrl}${categoryPayload.endpoint}${data}`, {
        method: "GET",
        headers: setHeader()
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.contentList(context, payload)))

        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  contentListMetaCall: (context, payload) => {
        return new Promise((resolve, reject) => {
     
          let data = makeQueryStringDync(payload.params);
          fetch(`${context.getters.vCmsBaseUrl}${payload.endpoint}${data}`, {
            method: "GET",
            headers: setHeader(),
          })
            .then((response) => errorHandlerMiddleware(response, () => actions.contentList(context, payload)))
    
            .then((data) => {
              resolve({ data });
            })
            .catch((error) => {
              reject(error);
           });
       });
      },
  listContent: (context, payload) => {
    const contentRestrictionPlanIds = context.getters.appConfig.contentRestrictionPlanIds || {};
    const subscriptionList = context.getters.subscriptionList || [];
    return new Promise((resolve, reject) => { 
      if (payload?.incontentprovider) {
        payload.incontentprovider = encodeURIComponent(JSON.stringify(payload.incontentprovider));
      } else if(getNotInContentProvider(subscriptionList, contentRestrictionPlanIds)) {
        payload.notincontentprovider = encodeURIComponent(JSON.stringify(getNotInContentProvider(subscriptionList, contentRestrictionPlanIds)));
      }
      let data = makeQueryStringDync(payload);
      fetch(`${context.getters.vCmsCachingBaseUrl}subscriber/v1/content${data}`, {
        method: "GET",
        headers: setHeader(),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`
        // }
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.listContent(context, payload)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  listGenerContent: (context, payload) => {
    return new Promise((resolve, reject) => {
      let data = makeQueryStringDync(payload);
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/content/genre${data}`, {
        method: "GET",
        headers: setHeader(),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`
        // }
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.listContent(context, payload)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  listBundleItem: (context, payload) => {
    return new Promise((resolve, reject) => {
      let data = JSON.stringify(payload);
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/content/?contentlist=${data}`, {
        method: "GET",
        headers: setHeader(),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`
        // }
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.listBundleItem(context, payload)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getContent: (context, payload) => {
    return new Promise((resolve, reject) => {
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/content/${payload}`, {
        method: "GET",
        headers: setHeader(),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`
        // }
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.getContent(context, payload)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  contentDetail: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let objectId;

      if (typeof payload == "object") {
        objectId = payload.contentid;
      } else {
        objectId = payload;
      }
      let queryUrl = `${context.getters.vCmsCachingBaseUrl}subscriber/v1/content/${objectId}`;

      if (payload.params) {
        let dataParams = makeQueryStringDync(payload.params);
        queryUrl += dataParams;
      }

      let isAnonymousUser = localStorage.getItem("loginType") ? false : true;
      let headerObj;

      if (isAnonymousUser == true) {
        headerObj = {
          Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`,
        };
      } else {
        headerObj = {
          "X-SESSION": `${localStorage.getItem("subscriberToken")}`,
        };
      }
      fetch(queryUrl, {
        method: "GET",
        headers: setHeader(),
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.contentDetail(context, payload)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => reject(error));
    });
  },
  listSuggestions: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryStringDync(payload);
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/content/suggestions${data}`, {
        method: "GET",
        headers: setHeader(),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`,
        // },
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.listSuggestions(context, payload)))

        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  contentSearch: (context, payload) => {
    const contentRestrictionPlanIds = context.getters.appConfig.contentRestrictionPlanIds || {};
    const subscriptionList = context.getters.subscriptionList || [];

    if (controller || payload.query === "") {
      controller.abort();
    }

    controller = new AbortController(); 

    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      else if(getNotInContentProvider(subscriptionList, contentRestrictionPlanIds)) {
        payload.notincontentprovider = encodeURIComponent(JSON.stringify(getNotInContentProvider(subscriptionList, contentRestrictionPlanIds)));
      }
      let data = makeQueryStringDync(payload);
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/content/search${data}`, {
        method: "GET",
        headers: setHeader(),
        signal: controller.signal
        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`,
        // },
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.contentSearch(context, payload)))

        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  genreList: (context) => {
    return new Promise((resolve, reject) => {
      // if (!payload) {
      //   reject({ error: "payload not found" });
      // }
      // let data = makeQueryStringDync(payload);
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/content/genre`, {
        method: "GET",
        headers: setHeader(),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`,
        // },
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.genreList(context, payload)))

        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  genreContentList: (context, payload) => {

    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      // let data = makeQueryStringDync(payload);
      fetch(
        `${context.getters.vCmsBaseUrl}subscriber/v1/content?category=["${payload.category}"]&objecttype=${payload.objecttype}&genre=${payload.genre}&objectlanguage=["${payload.objectlanguage}"]&productionyear=${payload.productionyear}&pagesize=30`,
        {
          method: "GET",
          headers: setHeader(),

          // {
          //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`,
          // },
        }
      )
        .then((response) => errorHandlerMiddleware(response, () => actions.genreContentList(context, payload)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  //get content stream url//
  contentStreamUrl: (context, payload) => {
    console.log('contentStreamUrl_payload', payload)
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = toFormUrlEncoded(payload.params);
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/content/package/${payload.contentid}`, {
        method: "POST",
        body: data,
        headers: setHeader("formUrl"),
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.contentStreamUrl(context, payload)))

        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  //list related contents//
  relatedContents: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryStringDync(payload.params);
      fetch(`${context.getters.vCmsCachingBaseUrl}subscriber/v1/content/related/${payload.contentid}${data}`, {
        method: "GET",
        headers: setHeader(),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`,
        // },
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.relatedContents(context, payload)))

        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  listi18nLanguage: (context) => {
    return new Promise((resolve, reject) => {
      fetch(`${context.getters.vSmsBaseUrl}subscriberv2/v1/i18n/language`, {
        method: "GET",
        headers: setHeader(),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`,
        // },
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.listi18nLanguage(context, payload)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  authorizeCurrentStreamApi: (context) => {
    return new Promise((resolve, reject) => {
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/stream/content/authorize`, {
        method: "GET",
        headers: setHeader(),
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.authorizeCurrentStreamApi(context)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setCurrentStreamApi: (context, payload) => {
    let data = toFormUrlEncoded(payload.params);

    return new Promise((resolve, reject) => {
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/stream/content/${payload.contentId}`, {
        method: "POST",
        body: data,
        headers: setHeader(),
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.authorizeCurrentStreamApi(context)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  actGetDRMToken: (context, payload) => {
    return new Promise((resolve, reject) => {
      // let endPoint = 'subscriber/v1/content/drmtoken'
      let endPoint = 'subscriber/v2/content/drmtoken'
      fetch(`${context.getters.vCmsBaseUrl}${endPoint}`, {
        method: "POST",
        body: payload,
        headers: setHeader('formUrl'),
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.authorizeCurrentStreamApi(context)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  unsetCurrentStreamApi: (context, payload) => {

    return new Promise((resolve, reject) => {
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/stream/content/${payload.contentId}`, {
        method: "DELETE",
        headers: setHeader(),
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.authorizeCurrentStreamApi(context)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  actions,
};
